// Tipo de comisiones
const montoFijo     = 1;
const porcentaje    = 2;
const ivaMontoFijo  = 3;
const ivaPorcentaje = 4;
const servicio      = 5;
const ivaServicio   = 6;

// Procesador de pago
//const procesadorN2 = 2;
const transfer     = 1;
const t1           = 2;
const vesta        = 3;

// Emisor de la targeta
const targetaN2  = 0;
const visa       = 1;
const masterCard = 2;
const amex       = 3;

// Metodo de pago 
const metodoN2 = 0;
const debito   = 1;
const credito  = 2;
let cvv = false;

// Valida si una targeta es de tipo n2
function isN2(selectCardId){
    return (selectCardId == "claro-pay") ? true : false;
}

function getProcesadorPago(reglas, selectCardId){
    if(isN2(selectCardId)){
        cvv = false;
        return transfer;
    } else {
        let procesadorPago = reglas.rulesData.subCategories.find(item => item.subcategoryName === "BALANCEO");
        switch (procesadorPago.rule[0].ruleValue) {
            case "1":
                cvv = true;
                return t1;
            case "2":
                return vesta;
        }
         
    }
}

function getEmisorTargeta(mark){  
    switch (mark) {
        case "999":
            return targetaN2;
        case "1":
            return visa;
        case "2":
            return masterCard;
        case "3":
            return amex;
    }
}

function getMetodoPago(cardType){
    switch (cardType) {
        case "0":
            return metodoN2;
        case "1":
            return debito;
        case "2":
            return credito;
    }
}

export function calculateCommissions(
    reglas,
    amountValueForCommission,
    mark,
    selectCardId,
    cardType
) {

    let procesadorPago = getProcesadorPago(reglas, selectCardId);

    let emisorTargeta = getEmisorTargeta(mark);
    let metodoPago = getMetodoPago(cardType);

    let commissionKey = ("" + procesadorPago  + metodoPago + emisorTargeta);

    if(procesadorPago == transfer){
        commissionKey = "" + procesadorPago;
    }
    let commissionKeyValues = [
        {name: "montoFijo",     value: montoFijo     + commissionKey},
        {name: "porcentaje",    value: porcentaje    + commissionKey},
        {name: "ivaMontoFijo",  value: ivaMontoFijo  + commissionKey},
        {name: "ivaPorcentaje", value: ivaPorcentaje + commissionKey},
        {name: "servicio",      value: servicio      + commissionKey},
        {name: "ivaServicio",   value: ivaServicio   + commissionKey}
    ];
    //console.log(commissionKeyValues, "arreglo de comision key a buscar");
    let comisionValues = [];
    commissionKeyValues.map((commissionKey) =>{
        reglas.rulesData.subCategories[0].rule.find((item) => {
            if(item.commissionKey == commissionKey.value){
                const nameValue = commissionKey.name;
                const value = item.ruleValue;
                comisionValues.push({[nameValue] : parseFloat(value)});
            }
        });
    })
    // console.log(comisionValues, "finxd");
    //console.log(comisionValues[0].montoFijo );
    let comisionMetodoPagoFijo =  (comisionValues[0].montoFijo * (1 + comisionValues[2].ivaMontoFijo/100));
    let comisionMetodoPagoPorcentaje =  (comisionValues[1].porcentaje * (1 + comisionValues[3].ivaPorcentaje/100));
    let comisionServicio =  (comisionValues[4].servicio * (1 + comisionValues[5].ivaServicio/100));
    
    console.log([{
        comisionMetodoPagoFijo, 
        comisionMetodoPagoPorcentaje,
        comisionServicio, 
        cvv
    }], "Result")

    return [{
        comisionMetodoPagoFijo, 
        comisionMetodoPagoPorcentaje,
        comisionServicio, 
        cvv
    }];
}


